import {useEffect} from 'react'
import type {PreloadedQuery} from 'react-relay/relay-hooks/EntryPointTypes'
import type {GraphQLTaggedNode, OperationType} from 'relay-runtime'

import {useRunningBuildUpdater} from '../../../containers/RunningBuildUpdater'
import {useRefetchablePreloadedQuery} from '../../../hooks/relay/useRefetchablePreloadedQuery'
import {useThrottle} from '../../../hooks/useThrottle'
import {getBuildLocator} from '../../../rest/locators'
import {getBuildTestOccurrencesCount} from '../../../selectors'
import type {BuildId} from '../../../types'

import {useAppSelector} from 'src/hooks/react-redux'

const THROTTLER_TIMEOUT = 5000

export const useFetchBuildTestCounters = <TQuery extends OperationType>(
  buildId: BuildId,
  buildLocator: string = getBuildLocator(buildId),
  gqlQuery: GraphQLTaggedNode,
  preloadedQuery: PreloadedQuery<TQuery>,
  getVariables: (buildLocator: string) => TQuery['variables'],
): TQuery['response'] => {
  const [data, refetch] = useRefetchablePreloadedQuery(gqlQuery, preloadedQuery)
  const count = useAppSelector(state => getBuildTestOccurrencesCount(state, buildId))
  useRunningBuildUpdater(buildId)
  const fetchTestCounters = useThrottle(refetch, THROTTLER_TIMEOUT)
  useEffect(() => {
    fetchTestCounters(getVariables(buildLocator))
  }, [buildLocator, count, fetchTestCounters, getVariables])
  return data
}
